import TableSection from "./components/TableSection";
import { ReactComponent as ID } from "@/assets/icons/ID.svg";
import Button from "@/components/Button";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import getStockDetailInteractor, {
  StockDetailData,
} from "@/@core/interactor/stock/get-stock-detail.interactor";
import "./style.scss";

const StockTransferAdd = () => {
  const location = useLocation();
  const { state } = location;
  const { id } = state;

  const [stockTransferDetail, setStockTransferDetail] =
    useState<StockDetailData>();

  const getStockTransferDetail = async () => {
    try {
      const response = await getStockDetailInteractor({ stockId: id });

      const {
        data: { data },
      } = response;

      setStockTransferDetail(data);
    } catch (error: any) {
      setStockTransferDetail(undefined);
    }
  };

  useEffect(() => {
    getStockTransferDetail();
  }, []);

  return (
    <>
      <div className='stock-transfer-add-page-wrapper'>
        <div className='header-page'>
          <div>
            <h1>Add Stock Transfer</h1>
            <span className='sub-title'>
              Scan the product to record as stock.
            </span>
          </div>
          {/* <div className='btn-wrapper'>
            <Button
              label='Cancel'
              type='secondary'
              size='md'
              onClick={() => null}
            />
            <Button
              label='Save'
              size='md'
              startIcon='save'
              onClick={() => null}
            />
          </div> */}
        </div>
        <div className='divider' />

        <div className='scroll-wrapper'>
          <div className='stock-product-info-wrapper'>
            <div className='row'>
              <div className='label-wrapper'>
                <span>Product Information</span>
              </div>
              <div className='info-wrapper'>
                <div className='column'>
                  <span className='title'>Master SKU</span>
                  <span className='content'>
                    {stockTransferDetail?.product.master_sku ?? "-"}
                  </span>
                </div>
                <div className='column'>
                  <span className='title'>Season</span>
                  <span className='content'>
                    {stockTransferDetail?.product.season ?? "-"}
                  </span>
                </div>
                <div className='column'>
                  <span className='title'>Size</span>
                  <span className='content'>
                    {stockTransferDetail?.product.size ?? "-"}
                  </span>
                </div>
                <div className='column'>
                  <span className='title'>Colour</span>
                  <span className='content'>
                    {stockTransferDetail?.product.colour ?? "-"}
                  </span>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='label-wrapper'>
                <span>Warehouse Source</span>
              </div>
              <div className='info-wrapper'>
                <div className='column'>
                  <span className='title'>Warehouse Name</span>
                  <span className='content'>
                    {stockTransferDetail?.warehouse_source?.name ?? "-"}
                  </span>
                </div>
                <div className='column'>
                  <span className='title'>Warehouse Location</span>
                  <span className='content'>
                    <ID width={20} height={20} />{" "}
                    {stockTransferDetail?.warehouse_source?.address ?? "-"}
                  </span>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='label-wrapper'>
                <span>Warehouse Target</span>
              </div>
              <div className='info-wrapper'>
                <div className='column'>
                  <span className='title'>Warehouse Name</span>
                  <span className='content'>
                    {stockTransferDetail?.warehouse_target?.name ?? "-"}
                  </span>
                </div>
                <div className='column'>
                  <span className='title'>Warehouse Location</span>
                  <span className='content'>
                    <ID width={20} height={20} />
                    {stockTransferDetail?.warehouse_target?.address ?? "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='divider' />
          <div className='content'>
            <TableSection product_unit={stockTransferDetail?.product_unit} getStock={getStockTransferDetail} />
          </div>
        </div>
      </div>
    </>
  );
};

export default StockTransferAdd;
